<template>
  <div class="mainbody my-profile-page mt30">
<!--    <code>   {{ new_password }}</code>-->
    <div class="container-fluid">
      <div class="col-md-12">
        <div class="row">
         <div class="col-lg-8 col-lg-offset-2 col-md-6 col-md-offset-3 col-xs-12">
           <div class="customer-details profile-details-card">
             <div class="row">
               <div class="col-md-12 bill-info">
                 <h3 class="c-title">My Profile</h3>
                <div class="row profile-form-grid">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Full Name</label>
                  <input type="text" class="form-control" v-model="name" placeholder="Full Name">
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label>Phone Number</label>
                  <input type="text" class="form-control" v-model="phone" readonly placeholder="Phone Number">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>New Password</label>
                  <input type="password" class="form-control" v-model="new_password" placeholder="Password">
                  <small class="red-color text-uppercase" v-if="new_password.length>0 && new_password.length<6">Password Need to be Minimum 6 Character Long.</small>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Confirm Password</label>
                  <input type="password" class="form-control"  v-model="matchPassword" placeholder="Password">
               <small class="red-color text-uppercase" v-if="matchPassword.length>0 && btnStatus === false">Confirm Password Does  not Match</small>
                </div>
              </div>
              <div class="col-md-12 mb10">
                <div class="form-group">
                  <button class="btn btn-base pull-right mr0" @click="updateProfile"
                          :disabled="btnStatus == false"
                           >Update Profile</button>
                </div>
              </div>
            </div>
               </div>
             </div>
           </div>
         </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const $ = require('jquery');
  window.$ = $;
  $(function () {
    $(window)
      .scroll(function () {
        $('nav')
          .toggleClass('scrolled', $(this)
            .scrollTop() > 50);
      });

  });

  import axios from 'axios';

  export default {
    data() {
      return {
        carts: [],
        token: '',
        name: '',
        email: '',
        phone: '',
        new_password: '',
        matchPassword: '',
        btnStatus:false
      };
    },
    created: function () {
      //localStorage.clear();
    this.fetchUserInfo();
    },
    watch: {
      new_password() {
        let vm = this;
        vm.btnStatus = false;
      },
      matchPassword() {
        let vm = this;
        if(vm.matchPassword === vm.new_password){
          if(vm.matchPassword.length >5){
            this.btnStatus = true;
          }
        }else{
          this.btnStatus = false;
        }
      }
    },
    mounted() {
      // this.getImagesInfo()
      let vm = this;
      if (localStorage.getItem("carts")) {
        vm.carts = JSON.parse(localStorage.getItem("carts"));
      } else {
        vm.carts = [];
      }
      this.calculateCartTotal();
    },
    methods: {
      calculateCartTotal() {
        let vm = this;
        //calculate total  product  amount
        for (var i = 0, totalSum = 0; i < vm.carts.length; totalSum += vm.carts[i++].cart_quantity);
        $(".carts .badge").text(vm.carts.length);
      },
      fetchUserInfo() {
          this.name=JSON.parse(localStorage.getItem("userinfo")).name;
          // this.email=JSON.parse(localStorage.getItem("userinfo")).email;
          this.phone=JSON.parse(localStorage.getItem("userinfo")).phone;

          // this.country=JSON.parse(localStorage.getItem("userinfo")).country;
          // this.district=JSON.parse(localStorage.getItem("userinfo")).district;
          // this.area=JSON.parse(localStorage.getItem("userinfo")).area;
          // this.zip=JSON.parse(localStorage.getItem("userinfo")).zip;
          // this.address=JSON.parse(localStorage.getItem("userinfo")).address;
      },
      updateProfile: function () {
       if(JSON.parse(localStorage.getItem("logged_in_user_id"))){
         this.customer_id = JSON.parse(localStorage.getItem("logged_in_user_id"));
       }
        axios.post(this.globalUrl+'update-profile',
          {
            phone: this.phone,
            customer_id: this.customer_id,
            name: this.name,
            password: this.new_password,
          }, {crossdomain: true})
          //{ crossdomain: true },{headers: {"content-type" : 'application/json' }
          .then((response) => {
            //console.log(response);
              this.$toasted.show('Profile has  been Updated Successfully.', {
                type: 'success',
                icon: 'fa-check-circle'
              });
          })
          .catch((response) => {
           // console.log(response);
            //vm.$parent.endLoading();
            this.$toasted.show('Something Wrong Please Try again', {
              type: 'error',
              icon: 'fa-exclamation-triangle'
            });
          });
      // }
      // else{
      //   // if (!this.password) {
      //   //   this.$toasted.show('password Is Required.', {
      //   //     type: 'error',
      //   //     icon: 'fa-exclamation-triangle'
      //   //   });
      //   // }
      // }
      }
    }
  };
</script>
